import styled from 'styled-components';
import ScreenUtils from '@screen';

const GuideChannelRailOverflowContainer = styled.div<{ length: number }>`
  width: ${(props) => 131 + props.length * 365 * ScreenUtils.widthRatio}px;
  height: ${212 * ScreenUtils.widthRatio}px;
  overflow: hidden;
  position: absolute;
  left: ${145 * ScreenUtils.widthRatio}px;
`;

export default GuideChannelRailOverflowContainer;
